<script lang="ts">
  import WorkOrderPropertyTag from "../../../../../../../../../../../../../../_shared/_modules/work-order-property-tag"
  import type { AssignWorkOrderDraft, WorkOrderAssignmentRow } from "../../../../contract"
  import { workOrderAssignmentPropertyDisplay } from "../../../../_shared/_logic/01-assign-work-order-presentation"

  let {
    row,
    draft,
  }: {
    row: WorkOrderAssignmentRow
    draft: AssignWorkOrderDraft
  } = $props()

  const display = $derived(workOrderAssignmentPropertyDisplay(row, draft))
</script>

<div class="property-cell" class:disabled={row.disabled}>
  <WorkOrderPropertyTag
    tag={display.tag}
    tooltipContent={display.tooltipContent}
    disabled={row.disabled}
  />
</div>

<style lang="less">
  .property-cell {
    color: var(--text-invers-100);
    display: grid;
    gap: 0.24rem;
    min-width: 0;
  }
</style>
